import ValidatePage from "@/router/modules/methods/validate";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/final',
    name: 'Final',
    component: () => import('@/views/final/index.vue'),
    meta: {
        title: 'Финальный просмотр',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        await ValidatePage(next)
    }
}